<template>
  <el-alert
    v-if="faltantes.length > 0"
    type="warning"
    show-icon
    :closable="false"
    title="Configuraciones requeridas sin definir"
    :description="descripcion"
    style="margin-bottom: 12px"
  />
</template>

<script setup>
import {
  ref,
  computed,
  onMounted,
  watch,
} from 'vue';
import api from '@/services/api';

const props = defineProps({
  keys: {
    type: Array,
    required: true,
  },
});

const faltantes = ref([]);

const descripcion = computed(
  () =>
    `Las siguientes configuraciones no están definidas: ${faltantes.value.map((f) => f.descripcion).join(', ')}.`,
);

const validar = async () => {
  if (!props.keys?.length) {
    faltantes.value = [];
    return;
  }
  try {
    const { data } = await api.post('/configuracion-general/validar-configuraciones', {
      clavesInternas: props.keys,
    });
    faltantes.value = data.faltantes ?? [];
  } catch {
    faltantes.value = [];
  }
};

onMounted(validar);
watch(() => props.keys, validar, { deep: true });
</script>
